module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [_c('div', {
    ref: "content",
    class: _vm.content_class
  }, [_vm._t("default", null, {
    loadmore: _vm.loadmore
  })], 2), _vm._v(" "), _c('div', {
    class: _vm.status_class
  }, [(_vm.status === 'loading') ? _vm._t("loading", [_c('div', [_c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true
    }
  }), _vm._v("\n        加载中....\n      ")], 1)], {
    loadmore: _vm.loadmore
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'loadmore') ? _vm._t("loadmore", [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.loadmore($event)
      }
    }
  }, [_vm._v("点击加载更多")])], {
    loadmore: _vm.loadmore
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'error') ? _vm._t("error", [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.loadmore($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.error_msg) + " 点击重试")])], {
    loadmore: _vm.loadmore
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409a5b5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loadmore/Loadmore.vue
// module id = 642
// module chunks = 0